import { Tooltip as MUITooltip, Zoom } from "@mui/material";

import { TooltipProps } from "components/index.types";

const Tooltip = ({
  id,
  open,
  message,
  children,
  disableHoverListener,
  disableFocusListener,
}: TooltipProps) => {
  return (
    <MUITooltip
      id={id}
      open={open}
      title={message}
      arrow
      disableHoverListener={disableHoverListener}
      disableFocusListener={disableFocusListener}
      slots={{ transition: Zoom }}
    >
      {children}
    </MUITooltip>
  );
};

export default Tooltip;
